import React from 'react';
import { Box, Tabs, Tab, useMediaQuery, useTheme } from '@mui/material';

const TopBarComponent = ({ activeTab, setActiveTab }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: isMobile ? 1 : 0,
        width: '100%',
        padding: theme.spacing(1),
        margin: 'none',
        marginBlock: '1rem',
        boxSizing: 'border-box', // Ensure padding does not cause overflow
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleChange}
        indicatorColor="none"
        textColor="true"
        sx={{
          padding: '5px',
          marginBottom: isMobile ? 1 : 0,
          height: 'auto',
          borderRadius: '8px',
          background: 'background: #FCFCFC',
          '& .Mui-selected': {
            background: '#fff',
            border: '1px solid #979797',
            borderRadius: '8px',
            boxShadow: '2px 2px 8px 0px #0000001A',
          },
        }}
      >
        <Tab
          label="Reservations"
          sx={{
            marginInline: '1rem',
            padding: '8px 32px',
            width: 'auto',
            height: '44px',
            typography: 'body1',
            fontWeight: '400',
            marginLeft: '4px',
          }}
        />
        <Tab
          label="Issuable"
          sx={{
            marginInline: '1rem',
            padding: '8px 32px',
            width: 'auto',
            height: '44px',
            typography: 'body1',
            fontWeight: '400',
          }}
        />
        <Tab
          label="Purchases"
          sx={{
            marginInline: '1rem',
            padding: '8px 32px',
            width: 'auto',
            height: '44px',
            typography: 'body1',
            fontWeight: '400',
          }}
        />
        <Tab
          label="Workbenches"
          sx={{
            marginInline: '1rem',
            padding: '8px 32px',
            width: 'auto',
            height: '44px',
            typography: 'body1',
            fontWeight: '400',
          }}
        />
      </Tabs>
    </Box>
  );
};

export default TopBarComponent;
